module.exports = __webpack_public_path__ + "static/media/coffee-english.96c29d6b.jpeg";